<template>
    <loader-component v-if="showLoader"></loader-component>
    <div v-else>
        <!-- responsive-header -->
        <responsive-header-component></responsive-header-component>
        <!-- responsive-header -->

        <div class="wrapper default">

            <!-- header -->
            <header class="main-header default">
                <div class="container">
                    <header-component></header-component>
                </div>
                <navbar-component></navbar-component>
            </header>
            <!-- header -->


            <main class="profile-user-page default">
                <div class="container">
                    <div class="row">
                        <div class="profile-page col-xl-9 col-lg-8 col-md-12 order-2">
                            <router-view></router-view>
                        </div>
                        <div class="profile-page-aside col-xl-3 col-lg-4 col-md-6 center-section order-1">
                            <div class="profile-box">
                                <div class="profile-box-header">
                                    <div class="profile-box-avatar">
                                        <img id="PreviewImage" src="/assets/img/svg/user.svg" alt="">
                                    </div>
                                    <button data-toggle="modal" data-target="#myModal" class="profile-box-btn-edit"
                                        @click="ChangeProfileIamge()">
                                        <i class="fa fa-pencil"></i>
                                    </button>
                                    <input id="ProfileImaheInput" type="file" class="d-none" @change="ProfileImageChange" />
                                </div>
                                <input type="hidden" v-model="ProfileImageBase64" id="ProfileImageBase64">
                                <div class="profile-box-username">{{ userFullName }}</div>
                                <div class="profile-box-tabs">
                                    <router-link to="/changePassword" class="profile-box-tab profile-box-tab-access">
                                        <i class="now-ui-icons ui-1_lock-circle-open"></i>
                                        تغییر رمز
                                    </router-link>
                                    <a @click="signOut" class="sign-out profile-box-tab profile-box-tab--sign-out">
                                        <i class="now-ui-icons media-1_button-power"></i>
                                        خروج از حساب
                                    </a>
                                </div>
                            </div>
                            <div class="responsive-profile-menu show-md">
                                <div class="btn-group">

                                    <button type="button" class="btn btn-secondary dropdown-toggle" data-toggle="dropdown"
                                        aria-haspopup="true" aria-expanded="false">
                                        <i class="fa fa-navicon"></i>
                                        حساب کاربری شما
                                    </button>
                                    <div class="dropdown-menu dropdown-menu-right text-right">
                                        <router-link to="/info" tag="a" class="dropdown-item" active-class="active-menu">
                                            <i class="now-ui-icons users_single-02"></i>
                                            ویرایش اطلاعات
                                        </router-link>
                                        <router-link to="/credit" class="dropdown-item" active-class="active-menu">
                                            <i class="now-ui-icons shopping_credit-card"></i>
                                            اعتبار من
                                        </router-link>
                                        <router-link v-if="customerGroupId != 2" to="/orders" class="dropdown-item"
                                            active-class="active-menu">
                                            <i class="now-ui-icons files_single-copy-04"></i>
                                            سفارشات آنلاین
                                        </router-link>
                                        <router-link v-if="customerGroupId == 2" to="/colleagueOrder" class="dropdown-item"
                                            active-class="active-menu">
                                            <i class="now-ui-icons files_single-copy-04"></i>
                                            سفارشات من
                                        </router-link>
                                        <router-link to="/transactions" class="dropdown-item" active-class="active-menu">
                                            <i class="now-ui-icons location_pin"></i>
                                            آدرس های من
                                        </router-link>
                                        <router-link to="/transactions" class="dropdown-item" active-class="active-menu">
                                            <i class="now-ui-icons ui-2_favourite-28"></i>
                                            تراکنش های من
                                        </router-link>
                                        <router-link to="/customerReviews" class="dropdown-item" active-class="active-menu">
                                            <i class="now-ui-icons ui-2_chat-round"></i>
                                            نقد و نظرات
                                        </router-link>
                                        <router-link to="/customerQuestions" class="dropdown-item"
                                            active-class="active-menu">
                                            <i class="now-ui-icons education_paper"></i>
                                            پرسش و پاسخ
                                        </router-link>

                                    </div>
                                </div>
                            </div>
                            <div class="profile-menu hidden-md">
                                <div class="profile-menu-header">حساب کاربری شما</div>
                                <ul class="profile-menu-items">
                                    <li>
                                        <router-link to="/info" tag="a" active-class="active">
                                            <i class="now-ui-icons users_single-02"></i>
                                            ویرایش اطلاعات
                                        </router-link>
                                    </li>
                                    <li>
                                        <router-link to="/credit" tag="a" active-class="active">

                                            <i class="now-ui-icons shopping_credit-card"></i>
                                            اعتبار من
                                        </router-link>
                                    </li>
                                    <li v-if="customerGroupId != 2">
                                        <router-link to="/orders" active-class="active">
                                            <i class="now-ui-icons shopping_basket"></i>
                                            سفارشات آنلاین
                                        </router-link>
                                    </li>
                                    <li v-if="customerGroupId == 2">
                                        <router-link to="/colleagueOrder" active-class="active">
                                            <i class="now-ui-icons shopping_basket"></i>
                                            سفارشات من
                                        </router-link>
                                    </li>
                                    <li>
                                        <router-link to="/addresses" active-class="active">
                                            <i class="now-ui-icons location_pin"></i>
                                            آدرس های من
                                        </router-link>
                                    </li>
                                    <li>
                                        <router-link to="/transactions">
                                            <i class="now-ui-icons ui-2_favourite-28"></i>
                                            تراکنش های من
                                        </router-link>
                                    </li>
                                    <li>
                                        <router-link to="/customerReviews">
                                            <i class="now-ui-icons ui-2_chat-round"></i>
                                            نقد و نظرات
                                        </router-link>
                                    </li>
                                    <li>
                                        <router-link to="/customerQuestions">
                                            <i class="now-ui-icons education_paper"></i>
                                            پرسش و پاسخ
                                        </router-link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
            <footer-component></footer-component>
        </div>

    </div>
</template>

<script>

import { initialSite } from "../../module/initialSite";
import { httpPromise } from "../../module/httpUtility";
export default {
    data() {
        return {
            showLoader: false,
            ProfileImageBase64: "",
            ProfileImage: "",
        }
    },
    mounted() {
        httpPromise(this, '/v1/Identity/CustomersProfile/GetProfileImage', 'get', '',
            response => {
                toastr.remove();
                if (response.body != null && response.body != "") {
                    document.getElementById('PreviewImage').setAttribute('src',response.body);
                }

            },
            response => {
                toastr.remove();
                toastr.error(response.data.Message);

            });
    },
    computed: {
        userFullName: function () {
            return this.$store.getters.readUserFullName;
        },
        customerGroupId: function () {
            return this.$store.getters.readCustomerGroupId;
        },
    },
    beforeMount: function () {
        initialSite(this);
    },
    methods: {
        signOut() {
            localStorage.removeItem('accessToken');
            localStorage.removeItem('CartHashId');
            this.$store.commit('setUserFullName', '');
            this.isUserLogined = false;
            window.location.href = "/";
        },
        ChangeProfileIamge() {
            document.getElementById('ProfileImaheInput').click();
        },
        ProfileImageChange(e) {
            const file = e.target.files[0];
            this.getBase64(file);
            setTimeout(() => {
                var data = {
                    Image: document.getElementById('ProfileImageBase64').value
                }
                document.getElementById('PreviewImage').src = URL.createObjectURL(file);
                httpPromise(this, '/v1/Identity/CustomersProfile/UpdateProfileImage', 'post', JSON.stringify(data),
                    response => {
                        toastr.remove();
                        toastr.success(response.data.Message);
                        this.isShowSppiner = false;
                        this.resetForm();
                    },
                    response => {
                        toastr.remove();
                        toastr.error(response.data.Message);
                        this.isShowSppiner = false;
                    });
            }, 500);

        },
        getBase64(file) {
            var reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = function () {
                document.getElementById('ProfileImageBase64').value = reader.result;
            };
            reader.onerror = function (error) {
                console.log('Error: ', error);
            };
        }
    }
}
</script>

<style scoped>
.sign-out {
    cursor: pointer;
}
</style>